// The bottom of the sidebar: help, and the credit line.
//
// The app had a page footer under every screen — Contact Us, a copyright, the
// logo the sidebar already shows, and on phones social icons that linked to
// x.com and linkedin.com themselves rather than MSI's accounts. Logged-in apps
// do not carry a marketing footer; it floated mid-screen on short pages and
// added a bar to scroll past on long ones. What it held that staff use —
// getting help — lives here, always one click away (removed 2026-10-01).
//
// The signed-in user's row was here too, briefly; it moved to the top bar's
// right end the same day (NavBar).
import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutlined';
import SidebarNavItem from './sidebar/SidebarNavItem';
import { frameLine } from './frame';

/** Where "Help & contact" goes — the old footer's Contact Us target. */
export const HELP_URL = 'https://www.msilodging.com/';
const CREDIT_URL = 'https://squareplanit.com/';

const HELP_ITEM = { key: 'help', label: 'Help & contact', icon: <HelpOutlineIcon />, href: HELP_URL };

export default function SidebarFooter({ isExpanded }) {
  return (
    <Box sx={(theme) => ({ mt: 'auto', pt: 0.5, pb: isExpanded ? 1 : 1.5, borderTop: frameLine(theme) })}>
      <SidebarNavItem item={HELP_ITEM} active={false} expanded={isExpanded} />
      {isExpanded && (
        <Typography variant="caption" component="p" sx={{ color: 'text.disabled', px: 2.5, pt: 0.5, fontSize: '0.7rem', lineHeight: 1.4 }}>
          Powered by{' '}
          <Link href={CREDIT_URL} target="_blank" rel="noopener noreferrer" underline="hover" sx={{ color: 'text.secondary' }}>
            SquarePlanIT
          </Link>
        </Typography>
      )}
    </Box>
  );
}
